/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import InvoiceTextField from '../../../../InvoiceTextField';

const flexInputStyle = { flex: 1, marginLeft: 24 };
const rowStyle = { display: 'flex', flex: 1, marginBottom: 10 };

const InvoiceLineBasicInfoSection = props => {
  const handleInputChange = (ev, value, errorMessage) => props.onFieldChange(ev, value, errorMessage);

  const renderShipSection = shipSection => (
    <React.Fragment>
      <div style={ rowStyle }>
        <InvoiceTextField
          name={ `${shipSection}GeoCode` }
          label={ 'Geocode' }
          value={ props.invoiceLineData[`${shipSection}GeoCode`] }
          onChange={ handleInputChange }
          style={ { flex: 1 } }
          dataType="string"
          stringMaxLength={ 20 }
        />
        <InvoiceTextField
          name={ `${shipSection}Location` }
          label={ 'Location' }
          value={ props.invoiceLineData[`${shipSection}Location`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ flexInputStyle }
          dataType="string"
          stringMaxLength={ 20 }
        />
      </div>
      <div style={ rowStyle }>
        <InvoiceTextField
          name={ `${shipSection}LocationDescription` }
          label={ 'Location Description' }
          value={ props.invoiceLineData[`${shipSection}LocationDescription`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ { flex: 1 } }
          dataType="string"
          stringMaxLength={ 512 }
        />
      </div>
      <div style={ rowStyle }>
        <InvoiceTextField
          name={ `${shipSection}Address1` }
          label={ 'Address 1' }
          value={ props.invoiceLineData[`${shipSection}Address1`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ { flex: 1 } }
          dataType="string"
        />
      </div>
      <div style={ rowStyle }>
        <InvoiceTextField
          name={ `${shipSection}Address2` }
          label={ 'Address 2' }
          value={ props.invoiceLineData[`${shipSection}Address2`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ { flex: 1 } }
          dataType="string"
        />
      </div>
      <div style={ rowStyle }>
        <InvoiceTextField
          name={ `${shipSection}City` }
          label={ 'City' }
          value={ props.invoiceLineData[`${shipSection}City`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ { flex: 1 } }
          dataType="string"
        />
      </div>
      <div style={ { display: 'flex', flex: 1, marginBottom: 30 } }>
        <InvoiceTextField
          name={ `${shipSection}County` }
          label={ 'County' }
          value={ props.invoiceLineData[`${shipSection}County`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ { flex: 3 } }
          dataType="string"
        />
        <InvoiceTextField
          name={ `${shipSection}State` }
          label={ 'State' }
          value={ props.invoiceLineData[`${shipSection}State`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ flexInputStyle }
          dataType="string"
        />
        <InvoiceTextField
          name={ `${shipSection}ZipCode` }
          label={ 'Postal Code' }
          value={ props.invoiceLineData[`${shipSection}ZipCode`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ { flex: 2, marginLeft: 24 } }
          dataType="string"
          stringMaxLength={ 15 }
        />
      </div>
      <div style={ rowStyle }>
        <InvoiceTextField
          name={ `${shipSection}Country` }
          label={ 'Country' }
          value={ props.invoiceLineData[`${shipSection}Country`] }
          onChange={ handleInputChange }
          fullWidth={ true }
          style={ { flex: 1 } }
          dataType="string"
        />
      </div>
    </React.Fragment>
  );

  return (
    <div style={ { display: 'flex' } }>
      <div style={ { flex: 1 } }>
        <h1 className="invoice-line-section-title">Ship to</h1>
        { renderShipSection(`shipTo`) }
      </div>
      <div style={ { flex: 1, marginLeft: 48 } }>
        <h1 className="invoice-line-section-title">Ship from</h1>
        { renderShipSection(`shipFrom`) }
      </div>
    </div>
  );
};

InvoiceLineBasicInfoSection.propTypes = {
  invoiceLineData: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired
};

export default InvoiceLineBasicInfoSection;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/invoiceLineEditor/invoiceLineEditorSections/InvoiceLineShipSection.js